//
// Author(s):
// Fr. Matthew Spencer, OSJ <mspencer@osjusa.org>
//
// Copyright (c) 2008-2016 Fr. Matthew Spencer, OSJ
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
//

// generated based on the svg data
export let Glyphs = {
  None: {
    paths: [
      {
        type: "positive",
        data: ""
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    },
    origin: {
      x: 0,
      y: 0
    },
    align: "left"
  },
  AcuteAccent: {
    paths: [
      {
        type: "positive",
        data:
          "M4 0C-.614.52-.614.52-.803-3.182l60.768-108.422c4.52-7.182 10.543-13.67 18.075-13.67 5.27 0 14.31 1.264 23.346 7.793 7.53 5.223 8.803 11.752 8.803 16.975 0 3.917-.52 11.1-8.05 17.628L4 0z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 0, // TODO: figure out a better way to align this horizontally.  width should be 110.992,
      height: 125.794
    },
    origin: {
      x: 0.803,
      y: 125.274
    },
    align: "left"
  },
  GraveAccent: {
    paths: [
      {
        type: "positive",
        data:
          "M105.386.26C110 .78 110 .78 110.189-2.922l-60.768-108.422c-4.52-7.182-10.543-13.67-18.075-13.67-5.27 0-14.31 1.264-23.346 7.793-7.53 5.223-8.803 11.752-8.803 16.975 0 3.917.52 11.1 8.05 17.628L105.386.26z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 0, //110.992,
      height: 125.794
    },
    origin: {
      x: 0, // -110.992,
      y: 125.274
    },
    align: "left"
  },
  Circle: {
    paths: [
      {
        type: "positive",
        data:
          "M0 -50A50 50 0 0 0 100 -50 50 50 0 0 0 0 -50M10 -50A40 40 0 0 1 90 -50 40 40 0 0 1 10 -50"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 100
    },
    origin: {
      x: -50,
      y: 100
    }
  },
  Semicircle: {
    paths: [
      {
        type: "positive",
        data:
          "M0 -50A50 50 0 0 0 100 -50 5 5 0 0 0 90 -50 40 40 0 0 1 10 -50 5 5 0 0 0 0 -50"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 55
    },
    origin: {
      x: -50,
      y: 50
    }
  },
  ReversedSemicircle: {
    paths: [
      {
        type: "positive",
        data:
          "M0 0A50 50 0 0 1 100 0 5 5 0 0 1 90 0 40 40 0 0 0 10 0 5 5 0 0 1 0 0"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 55
    },
    origin: {
      x: -50,
      y: 50
    }
  },
  Stropha: {
    paths: [
      {
        type: "positive",
        data:
          "M1.22-73.438c4.165 13.02 12.238 27.084 24.217 42.188L49.657 0 34.812 27.344C18.666 55.47-.084 72.396-21.438 78.124c4.687-3.645 7.03-8.593 7.03-14.843 0-8.853-4.947-20.572-14.843-35.155L-48 0 1.22-73.438z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 97.657,
      height: 151.562
    },
    origin: {
      x: 48,
      y: 73.438
    },
    align: "left"
  },
  BeginningAscLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M-50 43.688V-61c4.167 7.292 12.76 10.938 25.78 10.938 9.376 0 20.053-1.563 32.032-4.688C31.773-60.48 45.833-71.677 50-88.344v117.97C43.75 42.645 32.812 51.5 17.187 56.186-.52 61.398-15.886 64-28.906 64-42.97 64-50 57.23-50 43.687z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 152.344
    },
    origin: {
      x: 50,
      y: 88.344
    },
    align: "left"
  },
  BeginningDesLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M-50-56.03c0-13.022 7.03-19.532 21.094-19.532 13.02 0 28.385 2.604 46.093 7.812C32.813-63.583 43.75-54.73 50-41.187V76C45.833 59.854 31.77 48.656 7.812 42.406c-11.98-3.125-22.656-4.687-32.03-4.687-13.022 0-21.615 3.905-25.782 11.718v-105.47z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 151.562
    },
    origin: {
      x: 50,
      y: 75.562
    },
    align: "left"
  },
  CustosDescLong: {
    paths: [
      {
        type: "positive",
        data:
          "M39.063 273.472c5.73.52 7.29-6.25 4.687-20.312V-65.59c-13.542 2.083-24.22 5.468-32.03 10.156C3.905-50.226 0-43.714 0-35.904V71.91c5.73-5.21 10.677-8.594 14.844-10.157 5.73-1.562 12.24-2.343 19.53-2.343v196.875c0 11.458 1.563 17.187 4.688 17.187"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 46.353,
      height: 339.582
    },
    origin: {
      x: 0,
      y: 65.59
    },
    align: "left"
  },
  CustosDescShort: {
    paths: [
      {
        type: "positive",
        data:
          "M34.375 191.923c0 8.333 1.563 12.24 4.688 11.72 3.125-.522 4.687-7.033 4.687-19.533v-250c-13.542 2.084-24.22 5.47-32.03 10.157C3.905-50.525 0-44.015 0-36.203V71.61c5.73-5.208 10.677-8.593 14.844-10.156 5.73-1.562 12.24-2.344 19.53-2.344v132.813z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 43.75,
      height: 270.053
    },
    origin: {
      x: 0,
      y: 65.89
    },
    align: "left"
  },
  CustosLong: {
    paths: [
      {
        type: "positive",
        data:
          "M39.063-269.562c5.73-.52 7.29 6.25 4.687 20.312V69.5c-13.542-2.083-24.22-5.47-32.03-10.156C3.905 54.134 0 47.624 0 39.812V-68c5.73 5.208 10.677 8.594 14.844 10.156 5.73 1.563 12.24 2.344 19.53 2.344v-196.875c0-11.458 1.563-17.187 4.688-17.187z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 46.353,
      height: 339.582
    },
    origin: {
      x: 0,
      y: 270.082
    },
    align: "left"
  },
  CustosShort: {
    paths: [
      {
        type: "positive",
        data:
          "M34.375-188.125c0-8.333 1.563-12.24 4.688-11.72 3.125.522 4.687 7.033 4.687 19.532v250c-13.542-2.083-24.22-5.468-32.03-10.156C3.905 54.324 0 47.813 0 40V-67.813c5.73 5.21 10.677 8.594 14.844 10.157 5.73 1.562 12.24 2.344 19.53 2.343v-132.812z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 43.75,
      height: 270.052
    },
    origin: {
      x: 0,
      y: 200.365
    },
    align: "left"
  },
  DoClef: {
    paths: [
      {
        type: "positive",
        data:
          "M0 98.406V-97.688C0-118 5.99-134.275 17.97-146.516c11.978-12.24 27.603-18.36 46.874-18.36 10.937 0 19.53 3.126 25.78 9.376s9.376 14.583 9.376 25v107.813l-6.25-5.47c-4.167-3.645-10.287-7.42-18.36-11.327-8.072-3.907-16.796-5.86-26.17-5.86-11.46 0-21.486 4.427-30.08 13.282-8.593 8.854-12.89 19.53-12.89 32.03s4.297 23.308 12.89 32.423c8.594 9.115 18.62 13.672 30.08 13.672 9.374 0 18.098-1.822 26.17-5.468 8.073-3.646 14.193-7.292 18.36-10.938l6.25-6.25V132c0 9.896-3.125 18.1-9.375 24.61-6.25 6.51-14.844 9.765-25.78 9.765-19.272 0-34.897-6.25-46.876-18.75C5.99 135.125 0 118.72 0 98.405z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 331.251
    },
    origin: {
      x: 0,
      y: 164.876
    },
    align: "left"
  },
  FaClef: {
    paths: [
      {
        type: "positive",
        data:
          "M85.156-32v193.75c0 9.375-1.562 14.323-4.687 14.844-1.564 0-2.605-.52-3.126-1.563-.52-1.04-.782-2.603-.78-4.686V56.28c-8.335-8.332-19.793-12.5-34.376-12.5-17.71 0-31.77 3.907-42.188 11.72V-32c0-18.23 14.193-27.344 42.578-27.344 28.385 0 42.578 9.115 42.578 27.344zM98.438 93V-92.156c0-19.27 5.73-34.896 17.187-46.875 11.458-11.98 26.562-17.97 45.313-17.97 10.937 0 19.14 2.865 24.61 8.594 5.467 5.73 8.202 13.542 8.202 23.437v103.126l-5.47-4.687c-3.645-3.647-9.374-7.293-17.186-10.94-7.813-3.645-15.886-5.467-24.22-5.468-11.978 0-22.004 4.167-30.077 12.5-8.073 8.334-12.11 18.36-12.11 30.08 0 11.717 4.037 22.004 12.11 30.858s18.1 13.28 30.078 13.28c8.333 0 16.406-1.822 24.22-5.468 7.81-3.645 13.54-7.03 17.186-10.156l5.47-5.468V125.81c0 9.896-2.865 17.84-8.594 23.83-5.73 5.988-13.802 8.983-24.22 8.983-18.75 0-33.853-6.12-45.31-18.36-11.46-12.24-17.19-27.994-17.19-47.265z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 193.752,
      height: 333.595
    },
    origin: {
      x: 0.001,
      y: 157.001
    },
    align: "left"
  },
  Flat: {
    paths: [
      {
        type: "positive",
        data:
          "M7.813-204.406c4.166 0 6.25 5.208 6.25 15.625L12.5-10.657C33.854 13.302 54.167 25.28 73.438 25.28c9.374 0 14.062-4.686 14.062-14.06 0-6.25-1.042-11.72-3.125-16.407-2.083-4.688-7.03-9.766-14.844-15.235-7.81-5.47-13.02-8.984-15.624-10.547L27.344-45.81V-80.97c17.187 0 33.073 4.82 47.656 14.454C89.583-56.88 96.875-47.376 96.875-38c0 67.708-.26 101.562-.78 101.563-38.543 0-69.532-12.24-92.97-36.72C0-52.322-1.042-123.936 0-188c0-10.937 2.604-16.406 7.813-16.406z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 97.917,
      height: 267.969
    },
    origin: {
      x: 1.042,
      y: 204.406
    },
    align: "left"
  },
  Mora: {
    paths: [
      {
        type: "positive",
        data:
          "M47.478-24c6.957 0 12.793 2.288 17.49 6.883C69.662-12.52 72-6.904 72-.267c0 6.64-2.337 12.352-7.033 17.118C60.27 21.618 54.435 24 47.477 24c-6.26 0-11.748-2.383-16.444-7.15C26.337 12.086 24 6.374 24-.265c0-6.638 2.337-12.255 7.033-16.85C35.73-21.713 41.217-24 47.478-24z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 48,
      height: 48
    },
    origin: {
      x: -24,
      y: 24
    },
    align: "left"
  },
  Natural: {
    paths: [
      {
        type: "positive",
        data:
          "M7.906-166.563c-2.864 0-5.614.52-8.218 1.563v13.28l.78 56.25.782 78.907v85.157c.52 3.646 2.604 5.73 6.25 6.25l23.438-3.906 23.437-3.907v29.69c0 42.186-.26 63.54-.78 64.06l6.25 2.345c1.04.52 2.082.78 3.124.78 2.603 0 4.947-1.3 7.03-3.905L67.656-71.25c-.52-2.604-2.083-3.906-4.687-3.906-7.814 0-17.19 1.04-28.126 3.125l-19.53 3.124.78-38.28V-165c-2.604-1.042-5.323-1.562-8.188-1.563zM55.938-40v71.875l-41.407 7.03c0-48.436.262-72.655.783-72.655L55.938-40z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 70.311,
      height: 330.469
    },
    origin: {
      x: 0.312,
      y: 166.563
    },
    align: "left"
  },
  Sharp: {
    paths: [
      {
        type: "positive",
        data:
          "m41.725,-73.773c-5.421,-0.241-10.878,5.856-6.549,12.357L67.061,-20.473 61.264,-12.5 13.436,-71.199c-5.634,-5.934-16.988,1.032-11.232,9.783L50.756,0.182 2.203,61.416c-6.745,7.984 3.442,17.859 11.232,9.783L61.264,12.5l5.797,7.973-31.885,40.943c-5.578,6.844 5.588,16.005 11.594,9.783L77.568,33.154 108.367,71.199c4.894,6.717 17.343,-1.575 11.232,-9.783L87.715,20.473 93.873,12.5 141.34,71.199c6.725,7.67 17.509,-2.248 11.596,-9.783L104.02,0.182 152.936,-61.416c5.52,-7.02-5.541,-16.309-11.596,-9.783L93.873,-12.5l-6.158,-7.973 31.884766,-40.943c5.407,-7.045-5.505,-15.924-11.232,-9.783L77.568,-33.154 46.77,-71.199c-1.435,-1.708-3.238,-2.494-5.044922,-2.574zM77.568,-8.516 84.09,0.182 77.568,8.516 70.684,0.182Z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 154.646,
      height: 147.987
    },
    origin: {
      x: 0,
      y: 74.098
    },
    align: "left"
  },
  OriscusAsc: {
    paths: [
      {
        type: "positive",
        data:
          "M50 30.25c0 12.5-3.125 21.354-9.375 26.562-3.125 2.605-7.813 3.907-14.063 3.907-3.125 0-5.99-.522-8.593-1.564-2.605-1.04-5.6-2.474-8.986-4.297C5.6 53.035 2.734 51.603.39 50.56c-2.343-1.04-5.338-2.474-8.984-4.296-3.646-1.823-6.77-3.256-9.375-4.297-2.603-1.043-5.468-1.564-8.593-1.564-6.25 0-10.937 1.563-14.062 4.688C-46.875 50.824-50 59.677-50 71.656v-106.25c0-13.02 3.125-21.875 9.375-26.562 3.125-2.604 7.813-3.906 14.063-3.907 3.125 0 5.99.52 8.593 1.563 2.605 1.042 5.73 2.474 9.376 4.297 3.646 1.823 6.51 2.995 8.594 3.516l10.938 5.468c6.25 3.126 11.458 4.69 15.624 4.69 6.25 0 10.938-1.564 14.063-4.69C46.875-55.426 50-64.02 50-76V30.25z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 147.656
    },
    origin: {
      x: 50,
      y: 76
    },
    align: "left"
  },
  OriscusDes: {
    paths: [
      {
        type: "positive",
        data:
          "M-50 30.844v-106.25c0 11.458 3.125 20.052 9.375 25.78 3.125 3.126 7.813 4.69 14.063 4.688 4.687 0 13.41-3.255 26.17-9.765 12.762-6.51 21.746-9.766 26.954-9.766 6.25 0 10.938 1.303 14.063 3.907C46.875-55.874 50-47.02 50-34V72.25c0-11.98-3.125-20.833-9.375-26.563C37.5 42.563 32.812 41 26.562 41 21.875 41 13.023 44.385 0 51.156c-4.167 2.604-8.594 4.948-13.28 7.032-4.69 2.083-9.116 3.124-13.283 3.124-6.25 0-10.937-1.302-14.062-3.906C-46.875 52.198-50 43.344-50 30.844z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 147.656
    },
    origin: {
      x: 50,
      y: 75.406
    },
    align: "left"
  },
  OriscusLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M 19.055,78.887 C 20.242,78.487 21.532,77.890 22.925,77.097 24.318,76.304 26.700882,74.417 30.074,71.438 33.447,68.458 36.524,64.985 39.303,61.019 42.083,57.052 44.563,51.396 46.743,44.05 48.923,36.704 50.013,28.671 50.013,19.950525 L 50.013,-34.226 C 50.013,-54.464 42.074,-64.584 26.195,-64.584 20.248,-64.584 11.519,-61.410 0.007,-55.064 -11.506,-48.717 -20.235,-45.544 -26.182,-45.544 -34.515,-45.544 -40.568,-48.520 -44.340791,-54.473 -48.114,-60.426 -50.000,-67.369 -50.000,-75.303 L -50.000,30.07 C -50.000,49.909 -42.060754,59.829 -26.182,59.829 -21.023,59.829 -12.39,56.455 -0.284,49.709 11.822,42.963 20.648,39.59 26.195,39.59 29.369,40.777 30.362,44.25 29.17479,50.009 27.988,55.768 26.001,62.020829 23.216,68.767 z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 147.656
    },
    origin: {
      x: 50,
      y: 75.406
    },
    align: "left"
  },
  PodatusLower: {
    paths: [
      {
        type: "positive",
        data:
          "M-4.688-30.28c22.396 0 34.636-.262 36.72-.782 5.728-1.563 8.593-5.21 8.593-10.938H50v97.656c0 2.604-1.302 4.167-3.906 4.688-5.21.52-21.355.78-48.438.78-23.958 0-38.54-.26-43.75-.78-2.604 0-3.906-1.302-3.906-3.906v-82.032c0-3.646 1.302-5.468 3.906-5.468h2.344c2.604.52 15.625.78 39.063.78z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 103.124
    },
    origin: {
      x: 50,
      y: 42
    },
    align: "left"
  },
  PodatusUpper: {
    paths: [
      {
        type: "positive",
        data:
          "M-46.094-63.78c13.542 0 24.61 2.473 33.203 7.42C-4.298-51.41 0-43.99 0-34.093V62h-9.375c0-10.938-2.604-19.14-7.812-24.61-5.21-5.468-14.844-8.203-28.907-8.202-18.23 0-33.333 4.166-45.312 12.5v-75.782c0-19.79 15.104-29.687 45.312-29.687z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 91.406,
      height: 125.781
    },
    origin: {
      x: 91.406,
      y: 63.781
    },
    align: "right"
  },
  Porrectus1: {
    paths: [
      {
        type: "positive",
        data:
          "M233.594 162.875c-58.855 0-107.032-6.25-144.53-18.75C34.895 125.895-11.46 99.855-50 66V-52.75C-21.354-24.625 26.302 6.885 92.97 41.78 123.697 57.928 163.54 66 212.5 66c21.354 0 34.635-9.896 39.844-29.688V151.94c0 7.29-6.25 10.937-18.75 10.937z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 302.344,
      height: 215.627
    },
    origin: {
      x: 50,
      y: 52.75
    },
    align: "left"
  },
  Porrectus2: {
    paths: [
      {
        type: "positive",
        data:
          "M309.375 259.375c-50.52 0-110.938-22.396-181.25-67.188C48.437 141.667-10.938 94.272-50 50V-68.75C0-3.125 60.417 52.083 131.25 96.875c58.333 36.98 110.677 58.854 157.03 65.625h7.033c16.145 0 26.822-9.896 32.03-29.688v114.844c0 7.812-5.99 11.72-17.968 11.72z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 377.343,
      height: 328.126
    },
    origin: {
      x: 50,
      y: 68.75
    },
    align: "left"
  },
  Porrectus3: {
    paths: [
      {
        type: "positive",
        data:
          "M309.375 355.78c-48.96-16.666-109.115-55.468-180.47-116.405C79.428 198.23 19.793 134.687-50 48.75V-70C20 40 94.104 103.79 135.25 148.063 190 200 230 230 288.28 258.906c4.168 2.083 8.334 3.125 12.5 3.125 12.5 0 21.355-10.937 26.564-32.81v114.06c0 9.376-3.386 14.063-10.156 14.064-2.084 0-4.688-.522-7.813-1.563z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 377.344,
      height: 427.345
    },
    origin: {
      x: 50,
      y: 70
    },
    align: "left"
  },
  Porrectus4: {
    paths: [
      {
        type: "positive",
        data:
          "M350 453.438c-52.754-22.397-120-77.345-201.74-164.844C90.87 227.656 24.784 147.708-50 48.75V-70C-8.84-1.25 58.406 86.51 151.74 193.28c60.868 69.793 119.13 124.22 174.782 163.282 5.797 3.646 11.014 5.47 15.652 5.47 12.173 0 21.45-11.72 27.826-35.157V441.72c0 9.373-3.19 14.06-9.565 14.06-2.9 0-6.377-.78-10.435-2.342z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 420,
      height: 525.78
    },
    origin: {
      x: 50,
      y: 70
    },
    align: "left"
  },
  PunctumCavum: {
    paths: [
      {
        type: "positive",
        data:
          "M0-60.906c33.333 0 50 9.635 50 28.906v94.53C39.062 51.595 22.396 46.126 0 46.126s-39.063 5.47-50 16.406V-32c0-19.27 16.667-28.906 50-28.906z"
      },
      {
        type: "negative",
        data:
          "M.08-42.56c9.585.206 20.126.53 27.954 6.822 4.96 3.9 4.71 10.792 4.574 16.482v51.278C22.09 27.066 7.283 26.072.168 26.01c-7.72.23-21.895.935-32.616 4.674.04-19.197-.083-38.395.064-57.59.567-7.5 7.834-12.33 14.62-13.774 5.818-1.498 11.857-1.86 17.844-1.88z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 123.438
    },
    origin: {
      x: 50,
      y: 60.906
    },
    align: "left"
  },
  PunctumQuadratum: {
    paths: [
      {
        type: "positive",
        data:
          "M0-60.906c33.333 0 50 9.635 50 28.906v94.53C39.062 51.595 22.396 46.126 0 46.126s-39.063 5.47-50 16.406V-32c0-19.27 16.667-28.906 50-28.906z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 123.438
    },
    origin: {
      x: 50,
      y: 60.906
    },
    align: "left"
  },
  PunctumQuadratumLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M0-36.5436c19.999799999999997 0 30 5.781 30 17.3436v56.717999999999996C23.437199999999997 30.956999999999997 13.4376 27.6756 0 27.6756s-23.4378 3.2819999999999996-30 9.843599999999999V-19.2c0-11.562 10.000200000000001-17.3436 30-17.3436z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 123.438
    },
    origin: {
      x: 50,
      y: 60.906
    },
    align: "left"
  },
  PunctumQuadratumAscLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M-50 43.688V-61c4.167 7.292 12.76 10.938 25.78 10.938 9.376 0 20.053-1.563 32.032-4.688C31.773-60.48 45.833-71.677 50-88.344v117.97C43.75 42.645 32.812 51.5 17.187 56.186-.52 61.398-15.886 64-28.906 64-42.97 64-50 57.23-50 43.687z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 152.344
    },
    origin: {
      x: 50,
      y: 88.344
    },
    align: "left"
  },
  PunctumQuadratumDesLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M-50-56.03c0-13.022 7.03-19.532 21.094-19.532 13.02 0 28.385 2.604 46.093 7.812C32.813-63.583 43.75-54.73 50-41.187V76C45.833 59.854 31.77 48.656 7.812 42.406c-11.98-3.125-22.656-4.687-32.03-4.687-13.022 0-21.615 3.905-25.782 11.718v-105.47z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 151.562
    },
    origin: {
      x: 50,
      y: 75.562
    },
    align: "left"
  },
  PunctumInclinatum: {
    paths: [
      {
        type: "positive",
        data: "M0-75.78L50 0 0 75-50 0 0-75.78z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 150.78
    },
    origin: {
      x: 50,
      y: 75.78
    },
    align: "left"
  },
  PunctumInclinatumLiquescent: {
    paths: [
      {
        type: "positive",
        data: "M 0,-53.164 35,-0.117 0,52.383 -35,-0.117 0,-53.164 z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 105.546
    },
    origin: {
      x: 50,
      y: 53.164
    },
    align: "left"
  },
  Quilisma: {
    paths: [
      {
        type: "positive",
        data:
          "M-50 34.938V-51c5.73 20.833 13.02 31.25 21.875 31.25 7.813 0 12.5-15.625 14.063-46.875 3.645 12.5 6.9 21.224 9.765 26.172s6.9 7.422 12.11 7.422c5.208 0 9.374-14.324 12.5-42.97 5.73 22.917 10.677 34.375 14.843 34.375 5.73 0 10.677-15.885 14.844-47.656v100c0 17.707-3.125 26.56-9.375 26.56-4.688 0-9.115-5.988-13.28-17.968-2.085 21.875-8.074 32.813-17.97 32.813-7.813 0-16.146-7.292-25-21.875-4.688 20.312-10.677 30.47-17.97 30.47-5.207 0-9.244-2.605-12.108-7.814C-48.568 47.698-50 41.708-50 34.938z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 150
    },
    origin: {
      x: 50,
      y: 89.282
    },
    align: "left"
  },
  TerminatingAscLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M-9.375 40.22c0-11.98-4.948-17.97-14.844-17.97-10.936 0-19.53 3.646-25.78 10.938v-53.126c0-6.77 2.604-12.76 7.813-17.968 5.208-5.21 10.677-8.594 16.406-10.157 2.603-.52 5.207-.78 7.81-.78 3.647 0 7.032.78 10.157 2.343C-2.603-43.896 0-39.73 0-34V73.03h-9.375V40.22z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 49.999,
      height: 121.873
    },
    origin: {
      x: 49.999,
      y: 48.843
    },
    align: "right"
  },
  TerminatingDesLiquescent: {
    paths: [
      {
        type: "positive",
        data:
          "M-9.375-48.156V-80.97H0V26.845c0 5.73-2.604 9.896-7.813 12.5-3.125 1.562-6.51 2.343-10.156 2.343-2.603 0-5.207-.26-7.81-.78-5.73-1.563-11.2-4.95-16.407-10.157C-47.398 25.542-50 19.292-50 12v-52.344c6.25 7.292 14.844 10.938 25.78 10.938 9.897 0 14.845-6.25 14.845-18.75z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 50,
      height: 122.658
    },
    origin: {
      x: 50,
      y: 80.97
    },
    align: "right"
  },
  VerticalEpisemaAbove: {
    paths: [
      {
        type: "positive",
        data: "M-8-4c2 3 6 4 8 4s6-1 8-4v-52c-2-3-6-4-8-4s-6 1-8 4z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 16,
      height: 60
    },
    origin: {
      x: 8,
      y: 60
    },
    align: "left"
  },
  VerticalEpisemaBelow: {
    paths: [
      {
        type: "positive",
        data: "M-8 56c2 3 6 4 8 4s6-1 8-4v-52c-2-3-6-4-8-4s-6 1-8 4z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 16,
      height: 60
    },
    origin: {
      x: 8,
      y: 0
    },
    align: "left"
  },
  VirgaLong: {
    paths: [
      {
        type: "positive",
        data:
          "M50-38v285.156c0 6.77-2.344 10.937-7.03 12.5-1.564 0-2.605-.78-3.126-2.344-.52-1.562-.782-10.156-.782-25.78V54.186C29.168 45.334 16.146 40.907 0 40.907c-22.917 0-39.583 5.208-50 15.624V-38c0-19.27 16.667-28.906 50-28.906S50-57.27 50-38z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 326.562
    },
    origin: {
      x: 50,
      y: 66.906
    },
    align: "left"
  },
  VirgaShort: {
    paths: [
      {
        type: "positive",
        data:
          "M50-38v211.72c0 7.29-2.344 11.457-7.03 12.5-1.564 0-2.606-.783-3.126-2.345-.52-1.563-.782-10.156-.782-25.78V54.187C29.167 45.332 16.146 40.906 0 40.906c-22.917 0-39.583 5.21-50 15.625V-38c0-19.27 16.667-28.906 50-28.906S50-57.27 50-38z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 100,
      height: 253.126
    },
    origin: {
      x: 50,
      y: 66.906
    },
    align: "left"
  },
  Virgula: {
    paths: [
      {
        type: "positive",
        data:
          "M8.178-55.66c0-22.137 12.092-33.2 36.287-33.2 11.835 0 23.53 5.66 35.108 16.98C91.15-60.547 96.94-41.766 96.94-15.534c0 53.515-31.646 87.487-94.937 101.895-2.048-2.06-3.077-5.146-3.077-9.273 0-1.03.247-1.8.76-2.316 42.71-19.027 64.075-41.678 64.075-67.92 0-11.322-2.325-20.326-6.945-27.016-4.62-6.69-9.52-11.052-14.676-13.11-5.147-2.048-11.836-3.85-20.07-5.403C12.81-39.707 8.18-45.37 8.18-55.66z"
      }
    ],
    bounds: {
      x: 0,
      y: 0,
      width: 98.014,
      height: 175.221
    },
    origin: {
      x: 1.074,
      y: 88.86
    },
    align: "left"
  }
};



// WEBPACK FOOTER //
// ./src/Exsurge.Glyphs.js